import React, { forwardRef, Ref, useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

import {
  StyledActionText,
  StyledContainerBorder,
} from 'src/presentation/components/pages/sidekick/threads/SidekickLayout';
import ConnectorWrapper from '../Connectors/ConnectorWrapper';
import { ConnectorsProviderContext } from '../Connectors/ConnectorsProvider';
import { LongTextWithTooltip } from 'src/presentation/components/pages/shared/LongTextWithTooltip';

type ParentItemProps = {
  parentItemId: string;
  onClick: (threadId: string) => void;
  thread: { id: string | number; name: string };
};

const ParentItem = forwardRef(({ parentItemId, thread, onClick }: ParentItemProps, ref: Ref<any>) => {
  const [isRegistered, setIsRegistered] = useState(false);

  const { registerLine } = useContext(ConnectorsProviderContext);

  const lineId = `parent_thread_${thread.id}`;

  useEffect(() => {
    if (isRegistered) {
      return;
    }

    registerLine(lineId, { source: { id: lineId }, destination: { id: parentItemId } });

    setIsRegistered(true);
  }, [lineId, isRegistered, registerLine, setIsRegistered, parentItemId]);

  const handleClick = () => {
    onClick(String(thread.id));
  };

  return (
    <ConnectorWrapper connectedPointPosition="bottom" id={`parent_thread_${thread.id}`} type="THREAD" meta={null}>
      <StyledItemContainer role="button" className="thread-reference" onClick={handleClick} ref={ref}>
        <LongTextWithTooltip value={thread.name} />
      </StyledItemContainer>
    </ConnectorWrapper>
  );
});

const StyledItemContainer = styled.div`
  ${StyledContainerBorder}
  ${StyledActionText}
  cursor: pointer;
  min-width: 30%;
  padding: 12px 16px;
  text-align: center;

  max-width: 200px;
`;

export default ParentItem;
